module.exports = __webpack_public_path__ + "img/gift4-01-c01-k1.850d805c.png";